module.exports = __webpack_public_path__ + "static/004_Room-a30af50451c3e3fd8ce773454d13270f.jpg";